import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { Context } from "./Context";
import Manager from "./Manager";
import { Printer } from "../Printer";
import { LocalApisClient } from "../../apis";
import { withAppApis, withAppUser } from "../../Context";
import * as AppActions from "../App/AppActions";

class LocalProvider extends React.Component {
  constructor(props) {
    super(props);
    this.manager = new Manager(props.localApis);
    this.printer = new Printer(props.localApis);
    this.state = props.initialState;
  }

  registerManagerListeners() {
    this.removeStatusListener = this.manager.addListener("status", ({
      detail
    }) => {
      const newState = { ...this.state,
        ...detail
      };
      this.setState(newState, () => {
        this.props.onChangeLocalAppStatus(newState);
      });
    });
  }

  unregisterManagerListeners() {
    this.removeStatusListener();
  }

  registerPrinterListeners() {
    this.printerReadyListener = this.printer.addListener("printer-ready", ({
      detail
    }) => {
      this.setState({
        isPrinterReady: true,
        printerConfig: detail
      });
    });
    this.printerFailListener = this.printer.addListener("printer-fail", ({
      detail
    }) => {
      this.setState({
        isPrinterReady: false,
        printerError: detail.error
      });
    });
  }

  unregisterPrinterListeners() {
    this.printerReadyListener && this.printerReadyListener();
    this.printerFailListener && this.printerFailListener();
  }

  componentDidMount() {
    this.registerManagerListeners();
    this.registerPrinterListeners();
    this.manager.checkStatus();
  }

  componentWillUnmount() {
    this.unregisterManagerListeners();
    this.unregisterPrinterListeners();
  }

  render() {
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: {
        state: this.state,
        manager: this.manager,
        printer: this.printer,
        localApis: this.props.localApis
      }
    }, this.props.children);
  }

}

LocalProvider.propTypes = {
  children: PropTypes.node,
  initialState: PropTypes.object,
  localApis: PropTypes.instanceOf(LocalApisClient),
  onChangeLocalAppStatus: PropTypes.func
};
LocalProvider.defaultProps = {
  initialState: {
    version: null,
    isRunning: false,
    isPrinterReady: false
  }
};
export default compose(withAppUser, withAppApis, connect(null, (dispatch, {
  appUser,
  appApis
}) => ({
  onChangeLocalAppStatus: async status => {
    try {
      if (status.version && status.version !== appUser.dpdLocalAppVersionActual) {
        await appApis.ums.updateUserAppVersion(status.version); // refresh app user once updated

        await dispatch(AppActions.getAppUser(appApis));
      }
    } catch (e) {// ignore error. it's not critical
    }
  }
})))(LocalProvider);